
import $ from 'jquery';

import 'jquery.easing';
import 'intersection-observer';

import globalelements from './global/elements';
import logger from './logger';


export default function (options) {
    var o = $.extend({
        // matches $backtotop-unfix-dist-from-footer
        unfixDistFromFooter: 0,

        // matches value in scss and Grid.js (prob doesnt need to though)
        transitionSpeed: 800,

        consoleOn: true
    }, options);


    var ele = {
        footer: $('footer'),
        backtotop: $('#backtotop'),

        sectionsWithDefinedColor: globalelements.sectionsWithDefinedColor
    };


    var internal = {
        name: 'BackToTop',

        backtotopObserver: null,
        backtotopColorObserver: null
    };


    var fn = {
        init: function () {
            fn.setupBacktotopObservers();

            ele.backtotop.on('click', handlers.backtotopClick);
        },

        setupBacktotopObservers: function () {
            // observer to fix/unfix back-to-top button
            var config = {
                root: null,
                rootMargin: o.unfixDistFromFooter + 'px 0px 0px 0px',
                threshold: 0
            };

            internal.backtotopObserver = new window.IntersectionObserver(handlers.backtotopObserver, config);
            internal.backtotopObserver.observe(ele.footer[0]);

            // observer to change button color
            /*
            var configColor = {
                root: null,
                rootMargin: '0px 0px 100% 0px',
                threshold: 0
            };

            internal.backtotopColorObserver = new window.IntersectionObserver(handlers.backtotopColorObserver, configColor);
            ele.sectionsWithDefinedColor.each(function () {
                internal.backtotopColorObserver.observe($(this)[0]);
            });
            */
        },

        setScrollPosition: function (offset, animate) {
            globalelements.scrollbody.animate({
                scrollTop: 0
            }, {
                duration: o.transitionSpeed,
                easing: 'easeOutQuad'
            });
        },

        console: function (msgs) {
            logger(msgs, {
                enabled: o.devMode,
                prefix: internal.name + '.js',
                prefixColor: 'magenta'
            });
        }
    };


    var handlers = {
        backtotopObserver: function (entries) {
            if (entries[0].isIntersecting) {
                ele.backtotop.addClass('state--unfixed');
            } else {
                ele.backtotop.removeClass('state--unfixed');
            }
        },
        backtotopColorObserver: function (entries) {
            var text = entries[0].target.dataset.text;

            console.log(text);

            if (text === 'white') {
                ele.backtotop.attr('data-color', 'white');
            } else {
                ele.backtotop.attr('data-color', '');
            }
        },
        backtotopClick: function () {
            fn.setScrollPosition(0, true);
        }
    };


    fn.init();
}
